var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-container"},[(_vm.chartLoading)?_c('scale-loader',{attrs:{"color":"#F26000"}}):_vm._e(),(!_vm.chartLoading)?_c('chart',{attrs:{"riasocCounts":this.riasoc_counts}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }